/* @flow */

import * as React from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import t from 'app/utils/translate';
import { Link } from 'react-router-dom';

import { FEATURED } from '../../constants/challengeCategoryTypes';
import Icon from '../commons/Icon';
import Responsive from '../responsive/Responsive';
import ChallengesFilterCategories from './ChallengesFilterCategories';
import FiltersToggleButton from '../commons/FiltersToggleButton';

type Props = {
  activeCategory: string,
  activeFilter?: string,
  categories: Array<Object>,
  displayCreateH2H: boolean,
  isActive?: boolean,
  isFiltered?: boolean,
  onCategoryChange: (?any) => void,
  onClick?: () => void,
  onReset: () => void,
  scheme?: 'light' | 'dark'
};

const defaultProps = {
  activeFilter: undefined,
  isActive: false,
  isFiltered: false,
  onClick: undefined,
  scheme: undefined
};

const Head = styled.div(({ theme }) => ({
  backgroundColor: theme.color.panel,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between'
}));

const Flex = styled.div({
  display: 'flex'
});

const CreateChallengeText = styled.div(({ theme }) => ({
  color: 'white',
  textTransform: 'uppercase',
  backgroundColor: theme.color.primary,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing.small
}));

const NewLabel = styled.span(({ theme }) => ({
  color: theme.color.primary,
  backgroundColor: 'white',
  borderRadius: '3px',
  padding: '0 3px',
  marginLeft: '5px'
}));

const CreateContestIcon = styled(Icon)({
  fontSize: '1.2rem',
  marginLeft: '0.2rem',
  marginBottom: '0.2rem'
});

function ChallengesFilterBarHead({
  activeCategory,
  activeFilter,
  categories,
  displayCreateH2H,
  isActive = defaultProps.isActive,
  isFiltered = defaultProps.isFiltered,
  onCategoryChange,
  onClick,
  onReset,
  scheme
}: Props) {
  return (
    <Head>
      {activeFilter !== FEATURED && categories.length > 0 && (
        <ChallengesFilterCategories
          activeCategory={activeCategory}
          items={categories}
          onSelect={onCategoryChange}
        />
      )}
      {activeFilter === FEATURED && <div />}
      <Flex>
        {onClick && (
          <FiltersToggleButton
            isOpen={isActive}
            isFiltered={isFiltered}
            onClick={onClick}
            onClear={onReset}
            scheme={scheme}
          />
        )}
        <Responsive desktop>
          {displayCreateH2H && (
            <Link to="/create-challenge">
              <CreateChallengeText>
                Create {t('Challenge')} <CreateContestIcon type="icon-create-contest" />
                <NewLabel>NEW</NewLabel>
              </CreateChallengeText>
            </Link>
          )}
        </Responsive>
      </Flex>
    </Head>
  );
}

ChallengesFilterBarHead.defaultProps = defaultProps;

function mapStateToProps({ settings }) {
  return {
    displayCreateH2H: settings.displayCreateH2H,
    scheme: settings.filters.theme
  };
}

export default connect(mapStateToProps)(ChallengesFilterBarHead);
